// 这里是用来兼容只有后缀但是要推导去真实的mimeType的情况
export var extToMimeTypeMap = {
  /* doc */
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  wps: 'application/kswps',
  wpt: 'application/kswpt',
  dot: 'application/msword',
  dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  docm: 'application/vnd.ms-word.document.macroEnabled.12',
  dotm: 'application/vnd.ms-word.template.macroEnabled.12',
  /* excel */
  xls: 'application/vnd.ms-excel',
  xlm: 'application/vnd.ms-excel',
  xla: 'application/vnd.ms-excel',
  xlc: 'application/vnd.ms-excel',
  xlt: 'application/vnd.ms-excel',
  xlw: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  csv: 'text/csv',
  xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
  et: 'application/kset',
  ett: 'application/ksett',
  /* ppt */
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ppt: 'application/vnd.ms-powerpoint',
  pps: 'application/vnd.ms-powerpoint',
  pot: 'application/vnd.ms-powerpoint',
  potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
  ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  dps: 'application/ksdps',
  dpt: 'application/ksdpt',
  pptm: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  potm: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
  ppsm: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
  /* text */
  lrc: 'text/lrc',
  asp: 'text/asp; charset=utf-8',
  txt: 'text/plain',
  html: 'text/html',
  md: 'text/markdown',
  /* code */
  c: 'text/x-c; charset=utf-8',
  cpp: 'text/x-c; charset=utf-8',
  h: 'text/x-chdr',
  asm: 'text/x-asm; charset=utf-8',
  s: 'text/x-asm; charset=utf-8',
  java: 'text/x-java-source; charset=utf-8',
  js: 'text/javascript',
  go: 'text/x-go',
  /* image */
  raw: 'image/x-sony-arw',
  bmp: 'image/bmp',
  pcx: 'image/x-pcx',
  tiff: 'image/tiff',
  gif: 'image/gif',
  exif: 'image/x-exif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  fpx: 'image/vnd.fpx',
  svg: 'image/svg+xml',
  psd: 'image/vnd.adobe.photoshop',
  cdr: 'image/x-cdr',
  pcd: 'image/x-photo-cd',
  dxf: 'image/vnd.dxf',
  ufo: 'image/x-ufo',
  eps: 'application/postscript',
  png: 'image/png',
  wmf: 'image/wmf',
  webp: 'image/webp',
  tga: 'image/x-tga',
  /* audio */
  mp3: 'audio/mpeg',
  acc: 'audio/aac',
  aac: 'audio/aac',
  flac: 'audio/x-flac',
  amr: 'audio/AMR',
  m4b: 'audio/mp4',
  m4a: 'audio/mp4',
  wma: 'audio/x-ms-wma',
  wav: 'audio/x-wav',
  cd: 'audio/x-cd',
  wave: 'audio/x-wave',
  aiff: 'audio/x-aiff',
  midi: 'audio/midi',
  ra: 'audio/x-realaudio',
  vqf: 'audio/x-twinvq',
  ogg: 'audio/ogg',
  ape: 'audio/x-ape',
  weba: 'audio/webm',
  'mpeg-4': 'audio/mpeg-4',
  /* video */
  mp4: 'video/mp4',
  '3gp': 'video/3gpp',
  asf: 'video/x-ms-asf',
  asx: 'video/x-ms-asf',
  avi: 'video/x-msvideo',
  dv: 'video/dv',
  flv: 'video/x-flv',
  f4v: 'video/x-f4v',
  m3u8: 'application/vnd.apple.mpegurl',
  mkv: 'video/x-matroska',
  qt: 'video/quicktime',
  mov: 'video/quicktime',
  mpg: 'video/mpeg',
  mpeg: 'video/mpeg',
  mts: 'video/mp2t',
  m4v: 'video/mp4',
  rmvb: 'application/vnd.rn-realmedia',
  rm: 'audio/x-pn-realaudio',
  webm: 'video/webm',
  wmv: 'video/x-ms-wmv',
  dat: 'video/dat',
  vob: 'video/x-ms-vob',
  /* archive */
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  z: 'application/x-compress',
  '7z': 'application/x-7z-compressed',
  pdf: 'application/pdf',
  /* drawing */
  vsdx: 'application/vnd.ms-visio.drawing',
  vsd: 'application/vnd.ms-visio.drawing',
  pos: 'application/vnd.pos',
  xmind: 'application/vnd.pos',
  ofd: 'application/ofd'
};
export var mimeTypeToExtMap = /* @__PURE__ */function () {
  var result = {};
  Object.keys(extToMimeTypeMap).forEach(function (key) {
    var mimeType = extToMimeTypeMap[key];
    result[mimeType] || (result[mimeType] = []);
    result[mimeType].push(key);
    result[mimeType].push(key);
  });
  return result;
}();
//# sourceMappingURL=ext-to-mimetype.js.map